export default {
  updateAssetImport(state, value) {
    state.assetImport = value;
  },
};
